export default __webpack_public_path__ + "static/media/deletedoc.53d65594.svg";